import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router'
import { useEffect } from 'react'
import { useLocation } from "react-router-dom";

import './App.css'
import './MApp.css'
import './print.css'
import './styles/ProgressiveHeroBg.css'

import Cookies from 'universal-cookie'
import { getBrowser } from './core.js'

import Home from './pages/Home/Home'
import Page404 from './pages/Page404/Page404'
import RechtlichesOverview from './pages/Rechtliches/RechtlichesOverview/RechtlichesOverview.js'
import Impressum from './pages/Rechtliches/Impressum/Impressum.js'
import Datenschutz from './pages/Rechtliches/Datenschutz/Datenschutz.js'
import DatenschutzBlackMamba from './pages/Rechtliches/DatenschutzBlackMamba/DatenschutzBlackMamba.js'
import AGB from './pages/Rechtliches/AGB/AGB.js'
import Barrierefreiheit from './pages/Rechtliches/Barrierefreiheit/Barrierefreiheit.js'
import Diversity from './pages/Rechtliches/Diversity/Diversity.js'
import NewsOverview from './pages/News/NewsOverview/NewsOverview.js'
import NewsDetails from './pages/News/NewsDetails/NewsDetails.js'
import About from './pages/About/About.js'
import ServicesOverview from './pages/Services/ServicesOverview/ServicesOverview.js';
import Pricing from './pages/Pricing/Pricing.js';
import Chat from './pages/Chat/Chat.js';
import PageConstruction from './pages/PageConstruction/PageConstruction.js';
import Support from './pages/Support/Support.js';
import Linktree from './pages/Linktree/Linktree.js';
import ServiceWebdev from './pages/Services/ServiceWebdev/ServiceWebdev.js';
import ServiceAppdev from './pages/Services/ServiceAppdev/ServiceAppdev.js';
import ServiceHosting from './pages/Services/ServiceHosting/ServiceHosting.js';
import ServiceAI from './pages/Services/ServiceAI/ServiceAI.js';
import ServiceMedia from './pages/Services/ServiceMedia/ServiceMedia.js';
import ProjectsOverview from './pages/Projects/ProjectsOverview/ProjectsOverview.js';
import ProjectsDetails from './pages/Projects/ProjectsDetails/ProjectsDetails.js';
import FunnelKMU from './pages/Funnel/FunnelKMU/FunnelKMU.js';
import FunnelVeranstalter from './pages/Funnel/FunnelVeranstalter/FunnelVeranstalter.js';
import FunnelVerein from './pages/Funnel/FunnelVerein/FunnelVerein.js';
import FunnelStartup from './pages/Funnel/FunnelStartup/FunnelStartup.js';
import FunnelFoto from './pages/Funnel/FunnelFoto/FunnelFoto.js';
import FunnelsOverview from './pages/Funnel/FunnelsOverview/FunnelsOverview.js';
import Visitenkarte from './pages/Visitenkarte/Visitenkarte.js';

const cookies = new Cookies()


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};


export default function App() {
  useEffect(() => {
    try {
    } catch (e) {
      console.log(e)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let cur_userid = cookies.get('userid')
  let loggedin = (cur_userid != "" && cur_userid != undefined)

  let agentinfo = getBrowser(navigator.userAgent)
  let location = window.location

  return (
    <Router>
      <ScrollToTop />
      {/* basename={'/'} */}
      <Routes>

        {/* Redirect von alter Impressum/Datenschutz URL für Bestandsschutz: */}
        <Route path="/datenschutz.php" element={<Navigate to={"/rechtliches"} from={"/"} />} />
        {/* ------- */}

        {/* TODO LINKTREE */}
        <Route path="/linktree" element={<Linktree />} exact />
        <Route path="/l/:linkid" element={<Linktree />} exact />

        <Route path="/landing-visitenkarte" element={<Visitenkarte />} exact />
        {/* <Route path="/card" element={<Visitenkarte />} exact /> */}


        <Route path="/call" element={<PageConstruction />} exact />
        {/* Datenschutzhinweise zum VoiceBot Call Agent */}

        <Route path="/baustelle" element={<PageConstruction />} exact />

        <Route path="/services" element={<ServicesOverview />} exact />

        <Route path="/pricing" element={<Pricing />} exact />

        <Route path="/chat" element={<Chat />} exact />

        <Route path="/services/webdev" element={<ServiceWebdev />} exact />
        <Route path="/services/appdev" element={<ServiceAppdev />} exact />
        <Route path="/services/hosting" element={<ServiceHosting />} exact />
        <Route path="/services/ai" element={<ServiceAI />} exact />

        <Route path="/services/content" element={<ServiceMedia />} exact />
        <Route path="/services/photos" element={<ServiceMedia />} exact />
        <Route path="/media" element={<ServiceMedia />} exact />

        <Route path="/services/*" element={<PageConstruction />} />

        <Route path="/projects" element={<ProjectsOverview />} exact />
        {/* <Route path="/projects/*" element={<PageConstruction />} exact /> */}
        <Route path="/projects/:projectid" element={<ProjectsDetails />} exact />

        <Route path="/support" element={<Support />} exact />
        <Route path="/about" element={<About />} exact />

        <Route path="/news" element={<NewsOverview />} exact />
        <Route path="/news/:newsid" element={<NewsDetails />} exact />

        <Route path="/rechtliches" element={<RechtlichesOverview />} exact />
        <Route path="/rechtliches/impressum" element={<Impressum />} exact />
        <Route path="/rechtliches/datenschutz" element={<Datenschutz />} exact />
        <Route path="/rechtliches/services/blackmamba/datenschutz" element={<DatenschutzBlackMamba />} exact />
        <Route path="/rechtliches/agb" element={<AGB />} exact />
        <Route path="/rechtliches/barrierefreiheit" element={<Barrierefreiheit />} exact />
        <Route path="/rechtliches/diversity" element={<Diversity />} exact />

        <Route path="/funnel/kmu" element={<FunnelKMU />} exact />
        <Route path="/funnel/veranstalter" element={<FunnelVeranstalter />} exact />
        <Route path="/funnel/verein" element={<FunnelVerein />} exact />
        <Route path="/funnel/startup" element={<FunnelStartup />} exact />
        <Route path="/funnel/foto" element={<FunnelFoto />} exact />
        <Route path="/funnels" element={<FunnelsOverview />} exact />
        <Route path="/landing/startup-memmingen" element={<FunnelStartup />} exact />
        <Route path="/landing/startup-unterallgaeu" element={<FunnelStartup />} exact />
        <Route path="/landing/startup-allgaeu" element={<FunnelStartup />} exact />
        <Route path="/landing/startup-kempten" element={<FunnelStartup />} exact />
        <Route path="/landing/verein-memmingen" element={<FunnelVerein />} exact />
        <Route path="/landing/verein-unterallgaeu" element={<FunnelVerein />} exact />
        <Route path="/landing/verein-allgaeu" element={<FunnelVerein />} exact />
        <Route path="/landing/verein-kempten" element={<FunnelVerein />} exact />
        <Route path="/landing/event-memmingen" element={<FunnelVeranstalter />} exact />
        <Route path="/landing/event-unterallgaeu" element={<FunnelVeranstalter />} exact />
        <Route path="/landing/event-allgaeu" element={<FunnelVeranstalter />} exact />
        <Route path="/landing/event-kempten" element={<FunnelVeranstalter />} exact />
        <Route path="/landing/webdesign-memmingen" element={<FunnelKMU />} exact />
        <Route path="/landing/webdesign-unterallgaeu" element={<FunnelKMU />} exact />
        <Route path="/landing/webdesign-allgaeu" element={<FunnelKMU />} exact />
        <Route path="/landing/webdesign-kempten" element={<FunnelKMU />} exact />
        <Route path="/landing/eigeneapp-memmingen" element={<ServiceAppdev />} exact />
        <Route path="/landing/eigeneapp-kempten" element={<ServiceAppdev />} exact />
        <Route path="/landing/photograph-memmingen" element={<FunnelFoto />} exact />
        <Route path="/landing/photograph-unterallgaeu" element={<FunnelFoto />} exact />
        <Route path="/landing/photograph-allgaeu" element={<FunnelFoto />} exact />
        <Route path="/landing/photograph-kempten" element={<FunnelFoto />} exact />
        <Route path="/landing/ki-memmingen" element={<ServiceAI />} exact />
        <Route path="/landing/ki-unterallgaeu" element={<ServiceAI />} exact />
        <Route path="/landing/ki-allgaeu" element={<ServiceAI />} exact />
        <Route path="/landing/ki-kempten" element={<ServiceAI />} exact />

        <Route path="/" element={<Home />} exact />
        <Route path="/*" element={<Page404 />} />
        <Route element={<Page404 />} />

      </Routes>
    </Router >
  )
}

